import React, { useState, useEffect, useReducer, useRef } from "react";
import { useSelector } from "react-redux";
import _, { isEmpty } from "lodash";

import ScrollView from "devextreme-react/scroll-view";
import sa3 from "../../reducers/sa3";

import { FileUploader, DateBox, RadioGroup } from "devextreme-react";
import "../../styles/sps.css";
import SaveButton from "devextreme-react/button";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { TagBox } from "devextreme-react";
import { alert, confirm } from "devextreme/ui/dialog";
import * as actions from "../../actions/sa3";
import ResultChartPrint from "./ResultChartPrint";
import { onDownloadFile } from "../../common/utils";
import { postUserLog } from "../../actions/common";
import {
  searchValueByOneProperty,
  isDuplicatesByOneProperty,
} from "../settings/utils";

import DataGrid, {
  Column,
  Paging,
  Toolbar,
  Item,
  SearchPanel,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react";

const initialStates = {
  peopleList: [],
  userDetails: [],
};

const initialState = {
  confirmedResultsData: null,
  confirmedResultsGraphData: null,
};

const ConfirmedResult = (props) => {
  const [state, dispatch] = useReducer(sa3, initialState);
  let { confirmedResultsData, confirmedResultsGraphData, strategicA3Data } =
    state;
  const [gridData, setgridData] = useState([]);

  const [selectedVal, setselectedVal] = useState([]);
  const [dropdown, setdropdown] = useState([]);
  const productLabel = { "aria-label": "KPI" };
  const [runChartdata, setrunChartdata] = useState([]);
  const dataGridRef = useRef(null);
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [frequency, setfrequency] = useState("");
  const [enable, setenable] = useState(false);

  //Initial API Calls for Box 8 to Load
  useEffect(() => {
    actions.fetchConfirmedResults(dispatch, props.a3ID);
    actions.fetchConfirmedResultsGraph(dispatch, props.a3ID);
    actions.GetAttachmentsDataA3(dispatch, props.a3ID, "Results");
    actions.fetchData(dispatch, props.a3ID);
  }, []);

  useEffect(() => {
    setstartDate(strategicA3Data?.resultStartDate);
    setendDate(strategicA3Data?.resultEndDate);
    setfrequency(strategicA3Data?.resultFrequency);
    setenable(!isEmpty(strategicA3Data?.resultStartDate));
  }, [strategicA3Data]);

  //grid data and Graph data structure is modified as per the need
  // it takes care of filters that are previously applied
  //dropdown list values are also taken care
  useEffect(() => {
    // setgrid2Data(confirmedResultsData);
    if (!isEmpty(confirmedResultsData)) {
      const groupedData = confirmedResultsData?.reduce(
        (result, item) => {
          const existingGroup = result.find(
            (group) => group.KPIStateID === item.KPIStateID
          );

          if (existingGroup) {
            existingGroup.TableVal.push(item);
          } else {
            result.push({
              A3ID: item.A3ID,
              KPIStateID: item.KPIStateID,
              KPIStateName: item.KPIStateName,
              TableVal: [item],
            });
          }

          return result;
        },
        [confirmedResultsData]
      );

      const newData = groupedData?.map((group) => ({
        A3ID: group.A3ID,
        KPIStateID: group.KPIStateID,
        KPIStateName: group.KPIStateName,
        TableVal: group.TableVal,
      }));
      const uniqueKPIStates = [
        ...new Set(confirmedResultsData.map((item) => item.KPIStateName)),
      ];
      const dropdownval =
        selectedVal.length == 0 ? uniqueKPIStates : selectedVal;

      const filteredData = newData.filter((item) =>
        dropdownval.includes(item.KPIStateName)
      );
      setgridData(filteredData);

      setdropdown(uniqueKPIStates);
    }
  }, [confirmedResultsData]);
  useEffect(() => {
    if (!isEmpty(confirmedResultsGraphData) && confirmedResultsData !== null) {
      graphDataModify();
    }
  }, [confirmedResultsGraphData]);
  const graphDataModify = () => {
    const modifiedObj = {};
    confirmedResultsGraphData.forEach((item) => {
      const { kpiStateName, resultDate, target, actual, baseline, aop } = item;

      if (!modifiedObj[kpiStateName]) {
        modifiedObj[kpiStateName] = { kpiStateName, chartData: [] };
      }

      modifiedObj[kpiStateName].chartData.push({
        resultDate,
        target,
        actual,
        baseline,
        aop,
      });
    });

    const runChartData = Object.values(modifiedObj);
    const uniqueKPIStates = [
      ...new Set(confirmedResultsData?.map((item) => item.KPIStateName)),
    ];
    const dropdownval = selectedVal.length == 0 ? uniqueKPIStates : selectedVal;

    const filteredGraphData = runChartData.filter((item) =>
      dropdownval.includes(item.kpiStateName)
    );
    setrunChartdata(filteredGraphData);
  };

  const initialstateConfig = {
    showBorders: true,
    rowAlternationEnabled: true,

    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    sorting: {
      mode: "row",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    // searchPanel: {
    //   visible: true,
    // },

    export: {
      enabled: true,
      fileName: "Initial_State",
    },
    editing: {
      mode: "cell",
      allowUpdating: true,
    },
  };

  //filter data on dropdown selection of KPI

  return (
    <>
      <div style={{ display: "flex" }}>
        <div className="a3resultsgrid">
          {gridData?.map((item) =>
            item.A3ID != undefined ? (
              <div
                style={{
                  width: "500px",
                  minHeight: "1120px",
                }}
              >
                <h3 style={{ paddingBottom: "20px" }}>{item.KPIStateName}</h3>
                <table className="print-sps-tbl">
                  <thead>
                    <tr>
                      <th>Result Date</th>
                      <th>AOP</th>
                      <th>Actual</th>
                    </tr>
                  </thead>
                  {item.TableVal && item.TableVal.length > 0 && (
                    <tbody>
                      {item.TableVal.map((d, i) => (
                        <tr key={i}>
                          <td>{d.ResultDate}</td>
                          <td>{d.AOP}</td>
                          <td>{d.Actual}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
                {/* <DataGrid
                  style={{
                    paddingTop: "10px",
                    paddingRight: "20px",
                    width: "60% !important",
                  }}
                  // ref={dataGridRef}
                  dataSource={item.TableVal}
                  allowColumnReordering={true}
                  showBorders={true}
                  {...initialstateConfig}
                  wordWrapEnabled={true}
                  width={"100%"}
                  height={"100%"}
                >
                  <Toolbar>
                    <Item location="before">
                      <div className="informer">
                        <span className="name">{item.KPIStateName}</span>
                      </div>
                    </Item>
                    <Item name="searchPanel" visible={true} />
                  </Toolbar>
                  <Paging enabled={false} />
                  <Column
                    dataField="ResultDate"
                    caption="Result Date"
                    allowFiltering={false}
                    width={150}
                    allowEditing={false}
                  ></Column>
                  <Column
                    dataField="AOP"
                    caption="AOP"
                    allowFiltering={false}
                    width={150}
                  ></Column>
                  <Column
                    dataField="Actual"
                    caption="Actual"
                    allowFiltering={false}
                    width={100}
                  ></Column>
                </DataGrid> */}
              </div>
            ) : (
              ""
            )
          )}
        </div>
        <div>
          {confirmedResultsGraphData &&
            runChartdata.map((item) => (
              <div style={{ width: "900px", minHeight: "1120px" }}>
                <ResultChartPrint runChartdata={item}></ResultChartPrint>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};
export default ConfirmedResult;